// Provides api call methods
import ApiRoutes from '@/logic/ApiRoutes';
import {LogError} from '@/types/Analytics';
import store from '@/store';

export default class ApiHandler {

    // Perform API request
    // Raw returns response body, JSON otherwise
    // Errors are caugth and logged
    public static async request(request: Request, raw: boolean = false) {

        try {
            const response = await fetch(request);

            if (response.ok) {

                if (raw) {
                    return await response.text();
                } else {
                    return await response.json();
                }
                return await response.json();
            } else {
                const errorResponse = response;
                this.logHttpError(errorResponse);
            }
        } catch (error) {
            this.logFetchError(error);
        }

        return [];
    }

    // Get global heatmap data
    public static async fetchGlobalHeatmapData() {

        const request = ApiRoutes.getGlobalHeatmapRequest();

        const rawdata = await this.request(request);

        // Refactor data to usable form
        const data: any[] = [];
        rawdata.forEach((el: any) => {
            const row = [
                el.x_coord,
                el.y_coord,
                1
            ];
            data.push(row);
        });

        return data;
    }

    private static logFetchError(error: any) {

        store.dispatch('analytics/logError', {
            message: `Fetch error: ${error.message}`,
            details: JSON.stringify(error.stack)
        });
    }

    private static logHttpError(response: Response) {

        store.dispatch('analytics/logError', {
            message: `HTTP ${response.status} Error`,
            details: response.body
        });
    }
}
